import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';

const moneyFormat = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

const TypesenseProductCard = ({ hit }) => {
    const isLastChance = useMemo(() => {
        return hit?.badges?.some(badge => badge.type === 'last_chance');
    }, [hit]);

    const isEbay = hit?.brand === 'HGR eBay';
    const isAuction = hit?.brand === 'HGR Auctions';

    const displayPrice = () => {
        if (
            ((hit.on_sale || hit.is_markdown || isLastChance) && !hit.price_on_request) &&
            !isAuction &&
            !isEbay
        ) {
            return (
                <Price>
                    <Price__New>{moneyFormat.format(hit.sale_price)}</Price__New>
                    <Price__Old>{moneyFormat.format(hit.regular_price)}</Price__Old>
                </Price>
            );
        }

        if (isAuction) {
            return <Price>Opens at {moneyFormat.format(hit?.auction?.open_price)}</Price>;
        }

        if (hit.price_on_request) {
            return <Price>Price on Request</Price>;
        }

        return (
            <Price isEbay={isEbay} ebayBids={hit?.ebay?.bid_count}>
                {moneyFormat.format(hit.regular_price || hit.sale_price)}
            </Price>
        );
    };

    return (
        <Link href={hit.url} title={hit.title}>
            {hit?.images?.length > 0 && (
                <Image src={hit.images[0]} alt={hit.title} loading="lazy" />
            )}
            <Content>
                <Title
                    dangerouslySetInnerHTML={{
                        __html: hit._highlightResult?.title?.value || hit.title,
                    }}
                />
                <Category>
                    in <b>{hit.category}</b>
                </Category>
                {displayPrice()}
            </Content>
        </Link>
    );
};

export default TypesenseProductCard;

// ---------------------------
// Styled Components
// ---------------------------

const Link = styled.a`
  display: inline-flex;
  align-items: center;
  padding: 4px;
  text-decoration: none;
  gap: 12px;
  transition: box-shadow 0.2s ease;
`;

const Image = styled.img`
  width: 64px;
  height: 64px;
  object-fit: cover;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #333;
`;

const Category = styled.div`
  font-size: 12px;
  color: #777;
`;

const Price = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: bold;
  color: #333;

  ${({ isEbay, ebayBids }) =>
    isEbay &&
    css`
      &::after {
        content: '${ebayBids || 0} bids';
        color: #555;
        font-weight: 400;
        font-size: 13px;
        margin-left: 8px;
      }
    `}
`;

const Price__New = styled.span``;

const Price__Old = styled.span`
  text-decoration: line-through;
  font-weight: normal;
  color: #999;
`;

